module.exports = __webpack_public_path__ + "about-us-b998e096/map-182581ae9d90faf203884430c3a2fac2.svg";